export const MUTATION_ADD_PRODUCT = `mutation addProduct($input:AddProductInputType!){
  addProduct(input: $input){
    id
  }
}`